export default "__VITE_ASSET__BE99YJFh__"